import { ToastMessage } from "./toast-message";
import { useToastStore } from "./toast-store";

export const Toasts = () => {
  const toasts = useToastStore((state) => {
    return state.toasts;
  });
  const deleteToast = useToastStore((state) => {
    return state.deleteToast;
  });

  return !toasts.length ? null : (
    <div
      aria-live="assertive"
      className="pointer-events-none fixed inset-0 z-50 flex items-end overflow-hidden px-4 py-6 sm:items-start sm:p-6"
    >
      <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
        {toasts.map((toast) => {
          return (
            <ToastMessage
              key={toast.id}
              onClose={() => {
                return void deleteToast(toast.id);
              }}
              toast={toast}
            />
          );
        })}
      </div>
    </div>
  );
};
